/** Site-builder alias variant — same implementation as `dathacons-marquee`. */
export { default } from "./dathacons-marquee";
